import { createRicosNodeExtension } from './create-ricos-extension';

export const text = createRicosNodeExtension({
  groups: ['text'],
  type: 'html-node',
  name: 'text',
  createExtensionConfig() {
    return {
      name: this.name,
      group: 'inline',
    };
  },
});
